module.exports = __webpack_public_path__ + "static/media/gcdef_10006.f6a37252.ico";